import { render, staticRenderFns } from "./StudentContactBookDetail.vue?vue&type=template&id=7baef930&scoped=true&"
import script from "./StudentContactBookDetail.vue?vue&type=script&lang=js&"
export * from "./StudentContactBookDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentContactBookDetail.vue?vue&type=style&index=0&id=7baef930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baef930",
  null
  
)

export default component.exports